<template>
    <v-sheet>
        <h5 class="page-text--lg mb-8 mb-lg-16">발송리스트</h5>
        <v-divider class="primary border-2 mb-12 mb-lg-24" />
        <template v-for="item in textings">
            <v-card :key="item._id" outlined rounded class="texing-item">
                <div class="pa-20">
                    <v-row align-md="center">
                        <v-col cols="12" md="" class="texing-item__detail">
                            <p class="page-text--sm grey-9--text">
                                {{ item?.createdAt?.toDateTime?.() }}
                            </p>
                            <p class="page-text line-height-15">
                                {{ item?.message }}
                            </p>
                            <v-chip-group column class="mt-12" v-if="showsAddressees">
                                <template v-for="addressee in item.addressees">
                                    <v-chip small :key="addressee._user"> {{ addressee.name }} / {{ addressee.phone }} </v-chip>
                                </template>
                            </v-chip-group>
                        </v-col>
                        <v-col cols="auto">
                            <v-chip large color="grey-f1" class="rounded-sm">
                                <span class="grey-13--text"> 발송완료 <v-icon small class="ml-4">mdi-check</v-icon> </span>
                            </v-chip>
                        </v-col>
                    </v-row>
                </div>
            </v-card>
            <!-- <v-card :key="item._id" outlined class="my-20">
                <v-row no-gutters>
                    <v-col>
                        <v-card-subtitle>{{ item?.createdAt?.toDateTime?.() }}</v-card-subtitle>
                        <v-card-text style="white-space: pre-line"> {{ item?.message }} </v-card-text>
                    </v-col>
                    <v-col cols="auto">
                        <v-card-actions class="fill-height">
                            <v-btn> 발송완료 <v-icon small class="ml-6">mdi-check</v-icon> </v-btn>
                        </v-card-actions>
                    </v-col>
                </v-row>
            </v-card> -->
        </template>
    </v-sheet>
</template>

<script>
export default {
    props: {
        textings: { type: Array, default: () => [] },
        showsAddressees: { type: Boolean, default: false },
    },
};
</script>

<style lang="scss" scoped>
.texing-item:not(:last-child) {
    margin-bottom: 12px;
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
    .texing-item__detail {
        max-width: calc(100% - 115px);
    }
}
@media (min-width: 1024px) {
    .texing-item:not(:last-child) {
        margin-bottom: 24px;
    }
}
@media (min-width: 1200px) {
}
</style>